import { authenticationTypes } from 'root/src/shared/constants/auth'
import {
	LOGIN_ROUTE_ID,
	SIGN_UP_ROUTE_ID,
	VERIFY_NEW_EMAIL_ROUTE_ID,
	FORGOT_PASSWORD_ROUTE_ID,
	RESET_PASSWORD_ROUTE_ID,
	CONFIRM_FORGET_PASSWORD_ROUTE_ID,
	VERIFICATION_SUCCESS_ROUTE_ID,
	VERIFICATION_FAILURE_ROUTE_ID,
	VERIFICATION_FINISHED_ROUTE_ID,
	NEW_EMAIL_VERIFICATION_SUCCESS_ROUTE_ID,
	NEW_EMAIL_VERIFICATION_FAILURE_ROUTE_ID,
	SET_EMAIL_FAILURE_ROUTE_ID,
	TRANSFER_ACCOUNT_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'

import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls'

// Every route below is served by a redesign page in place at its own URL (the `Redesign*` components
// under src/client/v2/_pages/auth/redesign, mounted from src/client/pages). They therefore all carry
// `modules: []`: the global <RenderModules /> would otherwise paint the OLD page below the redesign
// one, and run its onEnter endpoints on SSR. See docs/redesign_auth_pages.md. The legacy modules
// themselves are untouched and still back the legacy sign-in / get-started modals.
//
// Authentication, noSitemap, noLoginRedirect and defaultRouteId are unchanged from the legacy routes.
export default {
	[LOGIN_ROUTE_ID]: {
		url: '/sign-in',
		noLoginRedirect: true,
		authentication: authenticationTypes.unauthenticated,
		modules: [],
	},
	[SIGN_UP_ROUTE_ID]: {
		url: '/sign-up',
		authentication: authenticationTypes.unauthenticated,
		defaultRouteId: SIGN_UP_ROUTE_ID,
		modules: [],
	},
	[routeUrls.signUpToken()]: {
		url: routeUrls.signUpToken(),
		modules: [],
	},
	[routeUrls.verifyAccount()]: {
		url: routeUrls.verifyAccount(),
		noSitemap: true,
		modules: [],
	},
	[VERIFY_NEW_EMAIL_ROUTE_ID]: {
		url: '/verify-new-email',
		noSitemap: true,
		modules: [],
	},
	// The legacy route appended the whole homepage below the failure message; the redesign page is
	// just the card, so `homepageModules` is gone along with the rest.
	[SET_EMAIL_FAILURE_ROUTE_ID]: {
		url: '/set-email-failure',
		noSitemap: true,
		modules: [],
	},
	[VERIFICATION_SUCCESS_ROUTE_ID]: {
		url: '/account-verified',
		noSitemap: true,
		authentication: authenticationTypes.unauthenticated,
		modules: [],
	},
	[VERIFICATION_FINISHED_ROUTE_ID]: {
		url: '/verify-account-finished',
		noSitemap: true,
		authentication: authenticationTypes.unauthenticated,
		modules: [],
	},
	[NEW_EMAIL_VERIFICATION_SUCCESS_ROUTE_ID]: {
		url: '/email-verified',
		noSitemap: true,
		modules: [],
		authentication: authenticationTypes.authenticated,
	},
	[NEW_EMAIL_VERIFICATION_FAILURE_ROUTE_ID]: {
		url: '/email-verification-failure',
		noSitemap: true,
		modules: [],
	},
	[VERIFICATION_FAILURE_ROUTE_ID]: {
		url: '/verify-account-failure',
		noSitemap: true,
		authentication: authenticationTypes.unauthenticated,
		modules: [],
	},
	[FORGOT_PASSWORD_ROUTE_ID]: {
		url: '/forgot-password',
		noSitemap: true,
		authentication: authenticationTypes.unauthenticated,
		modules: [],
	},
	[RESET_PASSWORD_ROUTE_ID]: {
		url: '/reset-password',
		noSitemap: true,
		noLoginRedirect: true,
		authentication: authenticationTypes.unauthenticated,
		modules: [],
	},
	[CONFIRM_FORGET_PASSWORD_ROUTE_ID]: {
		url: '/confirm-reset-password',
		noSitemap: true,
		authentication: authenticationTypes.unauthenticated,
		modules: [],
	},
	[TRANSFER_ACCOUNT_ROUTE_ID]: {
		url: '/transfer-account',
		noSitemap: true,
		authentication: authenticationTypes.unauthenticated,
		modules: [],
	},
}
